import { IconCase } from 'src/app/models/domain';

/**
 * Checks if a revision is a baseline revision.
 *
 * A baseline revision has no iteration suffix on its `revId`. Iterations of a baseline are
 * suffixed with a dot followed by digits, e.g. for `Q`, `Q.01`, `Q.02` the baseline is `Q`.
 *
 * @example
 * 'Q' -> true
 * 'Q.01' -> false
 * 'Q.1' -> false
 *
 * @param revId the revision id
 * @returns a boolean indicating if the revision is a baseline
 */
export const isBaselineRevision = (revId: string) => !/\.\d+$/u.test(revId);

/**
 * Checks if type is downlodable
 *
 * @example
 * 'UGMASTER' -> false
 * 'UGPART' -> false
 *
 * @param type the type of the item revision
 * @returns a boolean indicating if the item revision is downloadable
 */
export const isDownloadable = (type: keyof typeof IconCase) => {
  switch (type) {
    case 'UGMASTER':
      return false;
    case 'UGPART':
      return false;
    default:
      return true;
  }
};

/**
 * maps the item revision type to icon which is a string pointing to assets
 *
 * @example
 * 'UGMASTER' -> 'assets/tc-icons/nx.png'
 * 'UGPART' -> 'assets/tc-icons/nx-drawing.png'
 *
 * @param type the type of the item revision
 * @returns an IconCase enum pointing to assets
 */
export const mapTypeToIcon = (type: string) => {
  if (type in IconCase) {
    return IconCase[type as keyof typeof IconCase];
  }

  return IconCase.JPEG;
};
